import axios from '../base/axios';
import API_KEY from './key';

const GET_TVTALK = 'flixfrenzy/redux/GET_TVTALK';

// eslint-disable-next-line default-param-last
const tvTalkReducer = (state = [], action) => {
  switch (action.type) {
    case GET_TVTALK:
      return action.payload;
    default:
      return state;
  }
};

export const getTvTalk = () => (dispatch) => {
  axios.get(`discover/tv?api_key=${API_KEY}&with_genres=10767`).then((res) => {
    dispatch({
      type: GET_TVTALK,
      payload: res.data,
    });
  });
};

export default tvTalkReducer;
